Unit BaseSitePage;

Interface

Uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  WEBLib.ExtCtrls,
  WebForm.Core,
  App.Enumerations,
  App.Web.Consts,
  Web.Core.Consts,
  Data.DB,
  WEBLib.DB,
  WEBLib.DBCtrls;

Type
  TBaseSiteForm = Class(TCoreWebForm)
    InputQueryDlg: TInputMessageDlg;
    Procedure WebFormCreate(Sender: TObject);
  Private
    FPageLoading: Boolean;
    FOnSitePageChange: TOnSitePageChange;
    FDisplayingAs: TAppPage;
    FNavDirection: TNavDirection;
    FDoChangeSitePage: TChangeSitePage;
    Function GetPageHash: String;

    { Private declarations }
  Protected
    Procedure ReadyToProgress(Const CanProgress: Boolean); virtual;

    Procedure SetPageLoading(Const Value: Boolean); Virtual;

    Procedure SetDisplayingAs(Const Value: TAppPage); Virtual;
    Procedure UpdateMainForm;
    Function IsValid(Const AElementId: String; Const HighlightControls: Boolean): Boolean; Override;

    Procedure UpdatePolicyCosts; Virtual;
    Procedure ChangeSitePage(NewPage: TAppPage);
  Public
    { Public declarations }

    [async]
    Procedure InitForm; async; Override;
    [async]
    Procedure LoadData; async; Virtual;
    Procedure AfterLoaded; Virtual;

    [async]
    Function PreviewClose: Boolean; async; Virtual;
    Function CanClosePage: TCanProgress; Virtual;
    Procedure SaveThis; Virtual;

    Property OnSitePageChange: TOnSitePageChange Read FOnSitePageChange Write FOnSitePageChange;
    Property DoChangeSitePage: TChangeSitePage Read FDoChangeSitePage Write FDoChangeSitePage;
    Property DisplayingAs: TAppPage Read FDisplayingAs Write SetDisplayingAs;
    Property PageLoading: Boolean Read FPageLoading Write SetPageLoading;
    Property NavDirection: TNavDirection Read FNavDirection Write FNavDirection;
    Property PageHash: String Read GetPageHash;
  protected procedure LoadDFMValues; override; End;

Implementation

{$R *.dfm}

Uses
  System.DateUtils,
  Rtti,
  MainDataModule,
  SMX.Web.Table.Simple,
  SMX.Web.Utils,
  SMX.Web.Document.Utils,
  SMX.CRM.Utils,
  App.Web.Utils,
  XData.Dataset.Utils;


Procedure TBaseSiteForm.WebFormCreate(Sender: TObject);
Begin
  FPageLoading := True;
  FNavDirection := TNavDirection.ndNone;
  MainData.OnReadyToProgess := ReadyToProgress;
End;

{ TBaseBookingForm }

Procedure TBaseSiteForm.AfterLoaded;
Begin
  FPageLoading := False;
  HideWaitMessage;
End;

Function TBaseSiteForm.CanClosePage: TCanProgress;
Begin
  If IsValid('', True) Then
    Result := TCanProgress.ccImmediate
  Else
    Result := TCanProgress.ccNo;
End;

procedure TBaseSiteForm.ChangeSitePage(NewPage: TAppPage);
Begin
  If Assigned(FDoChangeSitePage) Then
    FDoChangeSitePage(NewPage, TNavDirection.ndNone);
End;

Function TBaseSiteForm.GetPageHash: String;
Begin
  Result := TRttiEnumerationType.GetName<TAppPage>(FDisplayingAs);
End;

Procedure TBaseSiteForm.InitForm;
Var
  lHash: String;
Begin
  Inherited;
  lHash := GetPageHash;
  If lHash <> Application.Hash Then
    window.location.Hash := lHash; // self.ClassName.Substring(1);

  UpdatePolicyCosts;
End;

Function TBaseSiteForm.IsValid(Const AElementId: String; Const HighlightControls: Boolean): Boolean;
Begin
  Result := Inherited IsValid(AElementId, HighlightControls);
End;

Procedure TBaseSiteForm.LoadData;
Begin
  // for descendants
End;

Function TBaseSiteForm.PreviewClose: Boolean;
Begin
  Result := True;
End;

procedure TBaseSiteForm.ReadyToProgress(const CanProgress: Boolean);
begin
  //for descendants, if needed
end;

Procedure TBaseSiteForm.SaveThis;
Begin
  MainData.SaveData;
End;

procedure TBaseSiteForm.SetDisplayingAs(Const Value: TAppPage);
Begin
  FDisplayingAs := Value;
End;

Procedure TBaseSiteForm.SetPageLoading(Const Value: Boolean);
Begin
  FPageLoading := Value;
End;

Procedure TBaseSiteForm.UpdatePolicyCosts;
Begin

End;

Procedure TBaseSiteForm.UpdateMainForm;
Begin
  If Assigned(FOnSitePageChange) Then
    FOnSitePageChange(Self);
End;

procedure TBaseSiteForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  InputQueryDlg := TInputMessageDlg.Create(Self);

  InputQueryDlg.BeforeLoadDFMValues;
  try
    Width := 1077;
    Height := 657;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    InputQueryDlg.SetParentComponent(Self);
    InputQueryDlg.Name := 'InputQueryDlg';
    InputQueryDlg.Left := 26;
    InputQueryDlg.Top := 24;
    InputQueryDlg.Width := 24;
    InputQueryDlg.Height := 24;
    InputQueryDlg.HeightStyle := ssAuto;
    InputQueryDlg.WidthStyle := ssAuto;
    InputQueryDlg.Buttons := [];
    InputQueryDlg.Opacity := 0.200000000000000000;
    InputQueryDlg.ElementButtonClassName := 'btn';
    InputQueryDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    InputQueryDlg.ElementTitleClassName := 'text-body';
    InputQueryDlg.ElementContentClassName := 'text-body';
  finally
    InputQueryDlg.AfterLoadDFMValues;
  end;
end;

End.
